import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { LegalSlug } from '../legal.models';
import { LegalService } from '../services/legal/legal.service';

@Component({
  selector: 'l-legal-link',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <button type="button" class="legal-link" (click)="open()">
      <ng-content />
    </button>
  `,
  styles: `
    .legal-link {
      padding: 0;
      border: 0;
      background: transparent;
      color: #0b3741;
      font: inherit;
      font-weight: 500;
      text-decoration: underline;
      text-underline-offset: 2px;
      cursor: pointer;
    }

    .legal-link:hover,
    .legal-link:focus-visible {
      color: #cc3366;
      text-decoration: underline;
    }
  `
})
export class LegalLinkComponent {
  public readonly slug = input.required<LegalSlug>();

  private readonly legalService = inject(LegalService);

  protected open(): void {
    this.legalService.openDocument(this.slug());
  }
}
